import React from 'react';
import { Icon, Button } from '@itglue/kaseya-ui';
import moment from 'moment';

export function SingleVideoView ( { title, description, iframe, date, onClick, onClickReturn, tag, tagColors,
    singleVideoSidebar, link }: any ) {
    let dateFormatted = moment(date).format('MMM DD, YYYY');
    let filteredTags = tag.filter((tagSuggested: any) => tagSuggested !== 'Suggested');

    return (
        <div className='itc-video-single__card' onClick={onClick}>
            {!singleVideoSidebar && <div className='itc-video-single__return' onClick={ onClickReturn }>
                <Icon fw regular className='itc-video-single__chevron' name='chevron-left'/>
                <span> {'Back to Tutorials'} </span></div>}
            <div className='itc-video-single__iframe' dangerouslySetInnerHTML={ iframe }></div>
            <div className='itc-video-single__info'>
                <div className='itc-video-single__title-button'>
                    <span className='itc-video-single__title'>{ title }
                        { tagColors && filteredTags?.map((tags: any, index: any) => {
                            return (
                                <span key={index} className={'itc-video-single__tag itc-video__tag--' + tagColors[tags]}>{tags}</span>);
                        }) } </span>
                    <Button className='itc-video-single__open-in-vimeo'><a className='itc-video-single__vimeo-link'
                        target='_blank' href={link}></a>
                    {'Open in Vimeo'}</Button>
                </div>
                <span className='itc-video-single__date'>{dateFormatted}</span>
                <span className='itc-video-single__description'>{ description }</span>
            </div>
        </div>
    );
}